import { render } from "./EmpresaSelector.vue?vue&type=template&id=dea988f0&scoped=true"
import script from "./EmpresaSelector.vue?vue&type=script&lang=js"
export * from "./EmpresaSelector.vue?vue&type=script&lang=js"

import "./EmpresaSelector.vue?vue&type=style&index=0&id=dea988f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea988f0"]])

export default __exports__